export const toCents = value => {
    const amount = Number(value);
    return Number.isFinite(amount) ? Math.round(amount * 100) : 0;
};

export const fromCents = value => Number((Number(value || 0) / 100).toFixed(2));

export const normalizeCurrency = value => fromCents(toCents(value));

export const sumCurrency = values => fromCents(values.reduce((total, value) => total + toCents(value), 0));

export const remainingTransactionAmount = transaction => {
    const amount = toCents(transaction?.amount);
    const refunded = toCents(transaction?.amount_refunded);
    const isCash = +transaction?.transaction_payment_method_id === 2
        || transaction?.transaction_payment_method_name === "Cash";
    const change = isCash ? toCents(transaction?.change) : 0;

    return fromCents(Math.max(0, amount - refunded - change));
};

export const flattenErrorMessage = error => {
    if (Array.isArray(error)) return error.map(flattenErrorMessage).filter(Boolean).join(" ");
    if (typeof error === "string") return error;
    if (!error || typeof error !== "object") return "";

    const directMessages = [error.error, error.message]
        .map(flattenErrorMessage)
        .filter(Boolean);
    if (directMessages.length > 0) return [...new Set(directMessages)].join(" ");

    return Object.values(error).map(flattenErrorMessage).filter(Boolean).join(" ");
};

export const isTokenOptionsPayload = data => Boolean(
    data
    && typeof data === "object"
    && typeof data.has_tokens === "boolean"
    && Array.isArray(data.tokens)
);

export const hasClawbackEligibleTokens = data => Boolean(
    isTokenOptionsPayload(data)
    && data.has_tokens
    && data.tokens.some(token => token?.status === "valid" && token?.can_claw_back === true)
);

export const hasSuccessfulResponseData = response => Boolean(
    response
    && typeof response === "object"
    && !response.error
    && !response.errors
    && Object.prototype.hasOwnProperty.call(response, "data")
    && response.data !== null
    && response.data !== undefined
);

export const isAmbiguousMutationResponse = response => {
    if (!response || typeof response !== "object") return true;
    if (response.reconciliation_required === true) return true;
    if (response.errors) return false;
    return !hasSuccessfulResponseData(response);
};
